const sassVars = require("!!sass-variables-loader!../styles/variables.scss") // import the variables from scss
import i18n from '../../public/texts.json'

import {
  MenuImg1847,
  MenuImg1856,
  MenuImg1898,
  MenuImg1899,
  MenuImg1902,
  MenuImg1900,
  MenuImg1904,
  MenuImg1904_2,
  MenuImg1909,
  MenuImg1911,
  MenuImg1912,
  MenuImg1914,
  MenuImg1917,
  MenuImg1924,
  MenuImg1925,
  MenuImg1925_2,
  MenuImg1928,
  MenuImg1933,
  MenuImg1942,
  MenuImg1948,
  MenuImg1967,
  MenuImg1968,
  MenuImg1969,
  MenuImg1971,
  MenuImg1973,
  MenuImg1976,
  MenuImg1978,
  MenuImg1983,
  MenuImg1983_2,
  MenuImg1984,
  MenuImg1985,
  MenuImg1989,
  MenuImg1996,
  MenuImg1997,
  MenuImg1999,
  MenuImg2000,
  MenuImg2001,
  MenuImg2003,
  MenuImg2005,
  MenuImg2006,
  MenuImg2007,
  MenuImg2007_2,
  MenuImg2010,
  MenuImg2012,
  MenuImg2014,
  MenuImg2015,
  MenuImg2018,
  MenuImg2019,
  MenuImg2019_2
} from '../../public/menu-img'

const DATES = [
  {
    data: `1847`,
    anchor: `1847`,
    text: ``,
    photo: MenuImg1847
  },
  {
    data: `1856`,
    anchor: `1856`,
    text: ``,
    photo: MenuImg1856
  },
  {
    data: `1898`,
    anchor: `1898`,
    text: ``,
    photo: MenuImg1898
  },
  {
    data: `1899`,
    anchor: `1899`,
    text: ``,
    photo: MenuImg1899
  },
  {
    data: `1902`,
    anchor: `1902`,
    text: ``,
    photo: MenuImg1902
  },
  {
    data: `1900`,
    anchor: `1900`,
    text: ``,
    photo: MenuImg1900
  },
  {
    data: `1904`,
    anchor: `1904`,
    text: ``,
    photo: MenuImg1904
  },
  {
    data: `1904`,
    anchor: `1904-2`,
    text: ``,
    photo: MenuImg1904_2
  },
  {
    data: `1909`,
    anchor: `1909`,
    text: ``,
    photo: MenuImg1909
  },
  {
    data: `1911`,
    anchor: `1911`,
    text: ``,
    photo: MenuImg1911
  },
  {
    data: `1912`,
    anchor: `1912`,
    text: ``,
    photo: MenuImg1912
  },
  {
    data: `1914`,
    anchor: `1914`,
    text: ``,
    photo: MenuImg1914
  },
  {
    data: `1917`,
    anchor: `1917`,
    text: ``,
    photo: MenuImg1917
  },
  {
    data: `1924`,
    anchor: `1924`,
    text: ``,
    photo: MenuImg1924
  },
  {
    data: `1925`,
    anchor: `1925`,
    text: ``,
    photo: MenuImg1925
  },
  {
    data: `1925`,
    anchor: `1925-2`,
    text: ``,
    photo: MenuImg1925_2
  },
  {
    data: `1928`,
    anchor: `1928`,
    text: ``,
    photo: MenuImg1928
  },
  {
    data: `1933`,
    anchor: `1933`,
    text: '',
    photo: MenuImg1933
  },
  {
    data: `1942`,
    anchor: `1942`,
    text: ``,
    photo: MenuImg1942
  },
  {
    data: `1948`,
    anchor: `1948`,
    text: ``,
    photo: MenuImg1948
  },
  {
    data: `1967`,
    anchor: `1967`,
    text: ``,
    photo: MenuImg1967
  },
  {
    data: `1968`,
    anchor: `1968`,
    text: ``,
    photo: MenuImg1968
  },
  {
    data: `1969`,
    anchor: `1969`,
    text: ``,
    photo: MenuImg1969
  },
  {
    data: `1971`,
    anchor: `1971`,
    text: ``,
    photo: MenuImg1971
  },
  {
    data: `1973`,
    anchor: `1973`,
    text: ``,
    photo: MenuImg1973
  },
  {
    data: `1977`,
    anchor: `1977`,
    text: ``,
    photo: MenuImg1976
  },
  {
    data: `1978`,
    anchor: `1978`,
    text: ``,
    photo: MenuImg1978
  },
  {
    data: `1983`,
    anchor: `1983`,
    text: ``,
    photo: MenuImg1983
  },
  {
    data: `1983`,
    anchor: `1983-2`,
    text: ``,
    photo: MenuImg1983_2
  },
  {
    data: `1984`,
    anchor: `1984`,
    text: ``,
    photo: MenuImg1984
  },
  {
    data: `1985`,
    anchor: `1985`,
    text: ``,
    photo: MenuImg1985
  },
  {
    data: `1989`,
    anchor: `1989`,
    text: ``,
    photo: MenuImg1989
  },
  {
    data: `1996`,
    anchor: `1996`,
    text: ``,
    photo: MenuImg1996
  },
  {
    data: `1997`,
    anchor: `1997`,
    text: ``,
    photo: MenuImg1997
  },
  {
    data: `1999`,
    anchor: `1999`,
    text: ``,
    photo: MenuImg1999
  },
  {
    data: `2000`,
    anchor: `2000`,
    text: ``,
    photo: MenuImg2000
  },
  {
    data: `2001`,
    anchor: `2001`,
    text: ``,
    photo: MenuImg2001
  },
  {
    data: `2003`,
    anchor: `2003`,
    text: ``,
    photo: MenuImg2003
  },
  {
    data: `2005`,
    anchor: `2005`,
    text: ``,
    photo: MenuImg2005
  },
  {
    data: `2006`,
    anchor: `2006`,
    text: ``,
    photo: MenuImg2006
  },
  {
    data: `2007`,
    anchor: `2007`,
    text: ``,
    photo: MenuImg2007
  },
  {
    data: `2007`,
    anchor: `2007-2`,
    text: ``,
    photo: MenuImg2007_2
  },
  {
    data: `2010`,
    anchor: `2010`,
    text: ``,
    photo: MenuImg2010
  },
  {
    data: `2012`,
    anchor: `2012`,
    text: ``,
    photo: MenuImg2012
  },
  {
    data: `2014`,
    anchor: `2014`,
    text: ``,
    photo: MenuImg2014
  },
  {
    data: `2015`,
    anchor: `2015`,
    text: ``,
    photo: MenuImg2015
  },
  {
    data: `2018`,
    anchor: `2018`,
    text: ``,
    photo: MenuImg2018
  },
  {
    data: `2019`,
    anchor: `2019`,
    text: ``,
    photo: MenuImg2019
  },
  {
    data: `2019`,
    anchor: `2019-2`,
    text: ``,
    photo: MenuImg2019_2
  }
]

const texts = i18n.filter(item => item.id === LANG_ID)[0].texts

DATES.forEach((item, index) => {
  item.text = texts[index + 1]['menu-title']
})

const constants = {

  CHANGE_ANCHOR: "CHANGE_ANCHOR",

  UI: i18n.filter(item => item.id === LANG_ID)[0].ui,

  MQ_XSMALL: parseInt(sassVars.MQ_XSMALL, 10),
  MQ_SMALL: parseInt(sassVars.MQ_SMALL, 10),
  MQ_MEDIUM: parseInt(sassVars.MQ_MEDIUM, 10),
  MQ_LARGE: parseInt(sassVars.MQ_LARGE, 10),
  MQ_XLARGE: parseInt(sassVars.MQ_XLARGE, 10),
  MQ_XXLARGE: parseInt(sassVars.MQ_XXLARGE, 10),

  MOBILE: "mobile",
  DESKTOP: "desktop",

  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",

  DATES: DATES,

  // Font Sizes
  h1: `tw-font-sans tw-text-xl md:tw-text-4xl lg:tw-text-5xl xl:tw-text-6xl 2xl:tw-text-7xl`,
  h2: `tw-font-sans tw-text-3xl tw-leading-none lg:tw-text-3xl`,
  h3: `tw-font-sans tw-text-2xl tw-leading-none lg:tw-text-xl`,
  h4: `tw-font-sans tw-text-2xl tw-leading-none lg:tw-text-xl`,
  h5: `tw-leading-none tw-text-sm`,
  quote: `tw-font-regular tw-text-xl lg:tw-text-4xl xl:tw-text-5xl 2xl:tw-text-6xl`,
  paragraph: `tw-font-body tw-text-base lg:tw-text-base`,
  caption: `tw-leading-none tw-font-sans tw-text-xs`,
  heading: `tw-font-regular tw-text-tiny`,
  attribution: `tw-font-mono tw-leading-none tw-text-xs lg:tw-text-xs`,
  active: `tw-font-regular tw-text-gold`,

  IMG_PATH: IMG_BASEPATH,
  LANG_ID: LANG_ID,
}

export default constants